$(document).each(function () {
    var $this = $(this);
    var btnSetting = $(this).find('.filter-button');

    btnSetting.click(function () {
        $(this).toggleClass('active');
        event.stopPropagation();
    });

    $(document).on('click', '.js-donation-button', function(e) {
    	$('.js-donation-button').removeClass('active');
    	$(this).addClass('active');
        $(this).parents('.b-filter__item').find('.js-open-modal span').text($(this).find('span.text').text());
    });
});


// WEBPACK FOOTER //
// ./src/js/pages/event-list/toggle-button.js